import { MERCHANT_ADMIN_MEMBER_LIST } from "constants/action-types";
import type { IAction, IFetchParams } from "epics/base-epic";
import { stringify } from "querystring";
import { Dispatch } from "react";
import type { IStore } from "reducers";
import { IMembersPayload } from "reducers/merchant-admin-member-list-reducers";
import siteConfig from "site-config";

const MEMBERS_PAGE_SIZE = 20;

export type FetchMembersOptions = {
    search_query?: string;
    order_by_field?: string;
    order_by_desc?: boolean;
};

export const fetchMembers =
    (merchantId: string, adminTeamId: string, { search_query, order_by_field, order_by_desc }: FetchMembersOptions) =>
    (dispatch: Dispatch<IAction<IFetchParams>>, getState: () => IStore) => {
        const { next_page_token } = getState().merchantAdminMemberList.members.payload;
        const query = stringify({
            page_size: MEMBERS_PAGE_SIZE,
            ...(next_page_token && { page_token: next_page_token }),
        });

        dispatch({
            type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.FETCH.START,
            payload: {
                method: "GET",
                url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/teams/${adminTeamId}/members?${query}`,
            },
        });
    };

export const resetMembers = () => ({ type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.RESET });

export const addMembers =
    (merchantId: string, adminTeamId: string, memberIds: string[]) => (dispatch: Dispatch<IAction<any>>) => {
        dispatch({
            type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.ADD.START,
            payload: { merchantId, adminTeamId, memberIds },
        });
    };

export const deactivateMember = (merchant_id: string, member_id: string) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.MEMBER.DEACTIVATE.START,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchant_id}/members/${member_id}/deactivate`,
    },
    meta: {
        member_id,
    },
});

export const activateMember = (merchant_id: string, member_id: string) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.MEMBER.ACTIVATE.START,
    payload: {
        method: "PATCH",
        url: `${siteConfig.goAPI}/v1/merchants/${merchant_id}/members/${member_id}/activate`,
    },
    meta: {
        member_id,
    },
});

export const updateMembers = (payload: Partial<IMembersPayload>) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.MEMBERS.UPDATE,
    payload,
});

export const setSuccessMessage = (message: string) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.SUCCESS_MESSAGE.SET,
    payload: message,
});

export const clearSuccessMessage = () => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.SUCCESS_MESSAGE.CLEAR,
});

export const setErrorMessage = (message: string) => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.ERROR_MESSAGE.SET,
    payload: message,
});

export const clearErrorMessage = () => ({
    type: MERCHANT_ADMIN_MEMBER_LIST.ERROR_MESSAGE.CLEAR,
});
